import { Directive, input } from '@angular/core';
import { QtySelectComponentDef } from '@df/ui/form/qty-select.component.def';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class QtySelectComponentDecoratorDef extends QtySelectComponentDef {
    readonly step = input<number>(1);

    override canMore(): boolean {
        const canMore = super.canMore();
        if (canMore && typeof this.max === 'number') {
            const moreValue = this.moreValue;
            if (moreValue && moreValue > this.max) {
                return false;
            }
        }
        return canMore;
    }

    override canLess(): boolean {
        const canLess = super.canLess();
        if (canLess && typeof this.min === 'number') {
            const lessValue = this.lessValue;
            if (lessValue && lessValue < this.min) {
                return false;
            }
        }
        return canLess;
    }

    private get moreValue(): number | undefined {
        const value = this.getValueForIncrementCheck();
        if (typeof value === 'number') {
            return value + this.step();
        }
        return undefined;
    }

    private get lessValue(): number | undefined {
        const value = this.getValueForIncrementCheck();
        if (typeof value === 'number') {
            const lessValue = value - this.step();
            if (lessValue > -1) {
                return lessValue;
            }
        }
        return undefined;
    }

    override less(): void {
        if (this.canLess()) {
            const lessValue = this.lessValue;
            if (typeof lessValue === 'number') {
                this.model = lessValue;
                this.detectChanges();
            }
        }
    }

    override more(): void {
        if (this.canMore()) {
            const moreValue = this.moreValue;
            if (typeof moreValue === 'number') {
                this.model = moreValue;
                this.detectChanges();
            }
        }
    }

    override validate(): void {
        super.validate();

        const step = this.step();
        const min = Math.max(0, typeof this.min === 'number' ? this.min : 0);
        let value = typeof this.model === 'number' ? this.model : min;

        if (value < min) {
            value = min;
        }

        if (step > 0) {
            const remainder = value % step;
            if (remainder !== 0) {
                value += step - remainder;
            }
        }

        if (value !== this.model) {
            this.model = value;
            this.detectChanges();
        }
    }
}
